module.exports = __webpack_public_path__ + "img/icon-sky-advanture.cec532dd.svg";